import yup from 'src/libs/yup';

const UserFilterSchema = yup.object().shape({
  name: yup.string().label('Nome'),
  email: yup.string().label('E-mail'),
  status: yup.string().nullable().label('Status'),
});

export default UserFilterSchema;
